import { Suspense, lazy } from 'react'
import { useSearchParams } from 'react-router-dom'
import { PageHeader } from '@/components/layout'
import { DashboardFinanciero } from '@/components/reportes/dashboard/DashboardFinanciero'
import { Skeleton } from '@/components/ui/skeleton'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'

const TableroRedes = lazy(() =>
  import('@/components/reportes/redes/TableroRedes').then((m) => ({ default: m.TableroRedes }))
)

type Pestana = 'finanzas' | 'redes'

const DESCRIPCION: Record<Pestana, string> = {
  finanzas: 'Cobrado, egresos y deuda del período',
  redes: 'Rendimiento de los reels y seguidores de Instagram',
}

/** Reportes con dos pestañas, Finanzas y Redes. La pestaña activa vive en `?tab=`. */
export function Reportes() {
  const [searchParams, setSearchParams] = useSearchParams()
  const pestana: Pestana = searchParams.get('tab') === 'redes' ? 'redes' : 'finanzas'

  const cambiarPestana = (valor: string) =>
    setSearchParams(valor === 'redes' ? { tab: 'redes' } : {}, { replace: true })

  return (
    <div className="flex flex-col h-full">
      <PageHeader title="Reportes" description={DESCRIPCION[pestana]} />
      <main className="flex-1 p-4 md:p-6">
        <Tabs value={pestana} onValueChange={cambiarPestana} className="space-y-4 md:space-y-6">
          <TabsList>
            <TabsTrigger value="finanzas">Finanzas</TabsTrigger>
            <TabsTrigger value="redes">Redes</TabsTrigger>
          </TabsList>
          <TabsContent value="finanzas">
            <DashboardFinanciero />
          </TabsContent>
          <TabsContent value="redes">
            <Suspense fallback={<Skeleton className="h-96 w-full" />}>
              <TableroRedes />
            </Suspense>
          </TabsContent>
        </Tabs>
      </main>
    </div>
  )
}
